var _rect, _rect2, _rect3, _rect4, _path, _path2, _polygon, _path3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 252 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#319208",
    width: 252,
    height: 126
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    fill: "#FFD200",
    width: 252,
    height: 90
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    fill: "#DE2010",
    width: 252,
    height: 54
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 54,
    width: 252,
    height: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.583,0l84,63l-84,63H0V0H4.583z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0,0l84,63L0,126"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DE2010",
    points: "46.161,66.045 64.434,53.111 43.405,50.056 34,31 24.595,50.056 3.566,53.111 21.839,66.045 17.836,85.248 34,76 50.164,85.248 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC618",
    d: "M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.2117
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.39,70.99c0,0,5.999-0.353,7.623-0.353c1.623,0,16.734,0.019,25.165,1.968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.508,70.871c0,0-0.601-0.728-0.213-2.175 c0.388-1.447,4.623-5.188,4.623-10.481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.142,70.637c0,0-0.494-2.364,4.905-4.376 c1.518-0.459,5.858-2.894,5.999-4.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473,66.485c0,0,13.243,0.058,23.724,2.175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.793,64.905c0,0,4.551,0.156,5.292-0.056c0.741-0.212,2.053-0.762,2.575-2.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.49,64.959c0,0,2.434-1.265,2.911-2.911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.141,81.894c0,0-1.041-7.216-1.253-11.257l2.717,2.594l2.875-2.514l2.472,2.638l2.858-2.425l2.471,2.778l2.83-2.407l2.252,2.618l2.822-2.041l3.355,3.189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.951,77.345c-10.081-1.444-23.57-1.35-23.57-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.694,51.052c0,0,8.2-3.918,9.647-4.465"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.211738,0,0,0.211738,16,36)",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "52.487,177.086 65.505,188.938 77.267,177.176 89.163,189.442 102.009,178.084 113.836,190.514 127.175,179.501 138.072,192.229 151.342,182.084 165.289,194.403"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.425,
    cy: 154.584,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.237,
    cy: 156.047,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.05,
    cy: 16.5,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.ad4af813ae5392742a5fbefbb8a21d23.svg";
export { ForwardRef as ReactComponent };